var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83:130",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83:130",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAB9ElEQVR4nO3dK04DYRiF4fNzS0jTgKLcFARVh0KwCCQGtgFUEBICYQNsAAyWBaAwOFRVdbmkpgjStAkMojWYoQwM/xn6Pqrq65e+TSczSWckAAAAAAAAAADwy0Kew6vV6tRrR8dJoh1JCxnHPISgy9K0Duv1eq/IewxjPK/BklQqz50kifYklX8wpixps9vT5Eu7dVPkPYYxkddgSRp8I7Ve29LMaiXTjHbjSfdn1wpBu5IOirzHMMbyGjywKCnzhyBJs2vzn2YVfI8v5R0E32QZ5K52FXsFSXH2sAziovP88ufvaRlk43Q79grRWAYZZZZBXI4hMVgGifHb7cIyyCgjiBmCmLEMMl2Zib1CNJZBOA+BDcsgnIeY4TwENghihiBmCGKGIGYIYoYgZghihiBmCGKGIGYIYoYgZghihiBmCGKGIGYIYoYgZghihiBmCGKGIGYIYoYgZghihiBmCGKGICli/HGIICli/HGIIGYIYoYgZghihiBmCGKGICm4o5wZ7igHgrghiBmCpODiohkuLoIgaTgPGeCOcmZc7ijHMQS5B3mQ+g9DyardeOy/CGr+gz2+lPcTdi5C0P792fXPZ72Hi6LvMYxcn0G1vDR32+1pMgStKOvzn4KaSRLOy6XkqNVqvRV5DwAAAAAAAAAAEMUHy0iQgvkjJzwAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.1d49d843.svg";
export { ForwardRef as ReactComponent };